import {Component, computed, inject, input, output} from '@angular/core';
import {FormActionButtonsComponent} from "../../common/forms/form-action-buttons/form-action-btns.component";
import {FormButtonComponent} from "../../common/forms/form-button/form-button.component";
import {SubtitlesService} from "../../core";
import {ActionType, ZonesListItem} from "../../models";
import {ChipComponent} from "../../common/chip/chip.component";
import {ZoneIconComponent} from "../../icons/zone-icon/zone-icon.component";
import {FormValueButtonComponent} from "../../common/forms/form-value-button/form-value-button.component";
import {FormCardButtonComponent} from "../../common/forms/form-card-button/form-card-button.component";

@Component({
    selector: 'zone-settings-dialog',
    standalone: true,
    imports: [
        FormActionButtonsComponent,
        FormButtonComponent,
        ChipComponent,
        ZoneIconComponent,
        FormValueButtonComponent,
        FormCardButtonComponent
    ],
    templateUrl: './zone-settings-dialog.component.html',
    styleUrl: './zone-settings-dialog.component.scss'
})
export class ZoneSettingsDialogComponent {
    private subtitlesService = inject(SubtitlesService);

    zone = input.required<ZonesListItem>();
    actionSelected = output<ActionType>();
    goBack = output<void>();
    showEditActions = computed(() => this.zone().status === 'noAlarm');
    showTurnOffAndResetActions = computed(() => this.zone().status === 'noAlarm' || this.zone().status === 'sensorDamaged');
    showTurnOnAction = computed(() => this.zone().status === 'zoneOff');

    protected labels = {
        turnOnZone: this.subtitlesService.setSubtitle(1163),
        turnOffZone: this.subtitlesService.setSubtitle(917),
        resetZone: this.subtitlesService.setSubtitle(1809),
        cancel: this.subtitlesService.setSubtitle(71),
        zoneName: this.subtitlesService.setSubtitle(3922),
        iconName: this.subtitlesService.setSubtitle(2910),
    }
}
